import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerX } from '@ng-icons/tabler-icons';
import { LayoutStoreService } from '@core/services/layout-store.service';
import type {
  LayoutPositionType,
  LayoutThemeType,
  SideNavType,
  TopBarType,
} from '@shared/types/layout';
import { toPascalCase } from '@shared/utils/string-utils';

const light = 'assets/images/layouts/light.svg';
const dark = 'assets/images/layouts/dark.svg';

const lightTopBarImg = 'assets/images/layouts/topbar-light.svg';
const darkTopBarImg = 'assets/images/layouts/topbar-dark.svg';

const lightSideNavImg = 'assets/images/layouts/light.svg';
const darkSideNavImg = 'assets/images/layouts/sidenav-dark.svg';

const smallSideNavImg = 'assets/images/layouts/sidebar-condensed.svg';

interface ThemeOptionType {
  theme: LayoutThemeType;
  image: string;
}

interface TopBarColorOptionType {
  color: TopBarType['color'];
  image: string;
}

interface SideNavColorOptionType {
  color: SideNavType['color'];
  image: string;
}

interface SideNavSizeOptionType {
  label: string;
  size: SideNavType['size'];
  image: string;
}

@Component({
  selector: 'app-customizer',
  imports: [SimplebarAngularModule, NgIcon],
  templateUrl: './customizer.html',
  viewProviders: [provideIcons({ tablerX })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomizerComponent {
  private activeOffcanvas = inject(NgbActiveOffcanvas);
  public layout = inject(LayoutStoreService);

  close(): void {
    this.activeOffcanvas.close();
  }

  themeOptions: ThemeOptionType[] = [
    { theme: 'light', image: light },
    { theme: 'dark', image: dark },
  ];

  topBarColorOptions: TopBarColorOptionType[] = [
    { color: 'light', image: lightTopBarImg },
    { color: 'dark', image: darkTopBarImg },
  ];

  sidenavColorOptions: SideNavColorOptionType[] = [
    { color: 'light', image: lightSideNavImg },
    { color: 'dark', image: darkSideNavImg },
  ];

  sidenavSizeOptions: SideNavSizeOptionType[] = [
    { size: 'default', image: lightSideNavImg, label: 'Default' },
    { size: 'collapse', image: smallSideNavImg, label: 'collapse' },
  ];

  layoutPositionOptions: Array<{ position: LayoutPositionType }> = [
    { position: 'fixed' },
    { position: 'scrollable' },
  ];
  protected readonly toPascalCase = toPascalCase;
}
